import { BlogSection } from '@/types/blog';

export const architekturMythos: BlogSection = {
  id: 'architektur-mythos',
  title: 'Die Architektur des Mythos: Von der Kanzel zum Bestseller',
  content: `
    <p class="mb-4">
      Um den Feind zu verstehen, musst du seine Wurzeln kennen. Der Mythos des positiven Denkens steht auf zwei Säulen:
    </p>
    
    <p class="mb-4">
      <strong>Norman Vincent Peale (Die Kraft des positiven Denkens, 1952):</strong> Im Nachkriegs-Amerika traf seine Mischung aus christlichem Glauben und praktischer Psychologie einen Nerv. Seine Technik: Erfolg visualisieren, Affirmationen wiederholen und Gott als eine Art kosmische Energiequelle anzapfen. Schon damals warnten Psychiater wie Albert Ellis, dass dies kritisches Denken untergrabe und zu erheblichen psychischen Problemen führen könne.
    </p>
    
    <p class="mb-4">
      <strong>Rhonda Byrne (The Secret, 2006):</strong> Mehr als 50 Jahre später wurde das gleiche Produkt neu verpackt. Die Rechtfertigung verlagerte sich von "Gott" zu einer pseudowissenschaftlichen "Quantenphysik" und dem "Gesetz der Anziehung". Das Kernversprechen blieb identisch: Deine Gedanken formen direkt die Realität.
    </p>
    
    <p class="mb-4">
      Beide verkaufen eine süße Lüge: Die Illusion der totalen Kontrolle in einer chaotischen Welt. Das Problem? Dieses Versprechen macht das Opfer zum Täter. Wer krank ist, arm oder unglücklich, hat einfach nicht "richtig" gedacht. Es ist ein System, das Mitgefühl durch Schuld ersetzt.
    </p>
  `
};
